import { media } from '@/utils/viewports';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 4rem 0 4rem 2.4rem;

  ${media.m} {
    margin: 4rem 2.4rem 0 2.4rem;
  }
  ${media.s} {
    margin: 4rem 0 0 0;
  }
`;

export const HelpPageContainer = styled.div`
  padding: 4rem;
  border-radius: 8px;
  gap: 3rem;
  background: ${props => props.theme.help.background};
  margin: 0 0 3rem 0;

  ${media.s} {
    border-radius: 0;
  }
`;

export const Title = styled.p<{ $isFaqs: boolean }>`
  font-family: ${props => props.theme.help.fontFamilyTitle};
  color: ${props => props.theme.help.titleColor};
  text-align: left;
  font-size: 34px;
  font-weight: 300;
  line-height: 51px;
  letter-spacing: 0em;
  margin-bottom: 1rem;

  ${media.m} {
    font-size: 28px;
  }

  ${media.s} {
    font-size: 28px;
    display: ${({ $isFaqs }) => ($isFaqs ? 'none' : 'block')};
  }
`;

export const SmallTitle = styled.p<{ $isFaqs: boolean }>`
  font-family: ${props => props.theme.help.fontFamilyTitle};
  color: ${props => props.theme.help.titleColor};
  text-align: left;
  font-weight: 300;
  letter-spacing: 0em;
  line-height: 1px;
  font-size: 1px;
  opacity: 0;

  ${media.s} {
    ${({ $isFaqs }) =>
      $isFaqs &&
      `
    line-height: 51px;
    font-size: 28px;
    opacity: 1;
  `}
  }
`;

export const Description = styled.p`
  font-family: ${props => props.theme.help.fontFamilyText};
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 300;
  line-height: 150%;
  text-align: left;
  color: ${props => props.theme.help.textColor};
`;

export const AccordionContainer = styled.div`
  background: ${props => props.theme.help.background};
  border-radius: 8px;

  ${media.s} {
    border-radius: 0;
  }
`;

export const OrderedListItemContainer = styled.ol`
  background: ${props => props.theme.help.background};
  border-radius: 8px;
  padding: 2rem 4rem 4rem;

  ${media.s} {
    border-radius: 0;
  }
`;

export const OrderedListItem = styled.li`
  padding: 2rem 0 0;
  // TODO: Decouple this element from these generic theme props.
  color: ${props => props.theme.help.textColor};
  font-family: ${props => props.theme.help.fontFamilyText};
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 400;
  line-height: 2.1rem;
`;
